import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicRating from './BasicRating';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicRating, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/rating/demos/basic/BasicRating.tsx",
    "fileName": "BasicRating.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Rating from '@mui/material/Rating';\nimport Typography from '@mui/material/Typography';\n\nexport default function BasicRating() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [value, setValue] = React.useState<number | null>(2);\n\n  return (\n    <Box sx={{ '& > legend': { mt: 2 } }}>\n      <Typography component=\"legend\">Controlled</Typography>\n      <Rating\n        name=\"simple-controlled\"\n        value={value}\n        onChange={(event, newValue) => {\n          setValue(newValue);\n        }}\n      />\n      <Typography component=\"legend\">Uncontrolled</Typography>\n      <Rating\n        name=\"simple-uncontrolled\"\n        onChange={(event, newValue) => {\n          console.log(newValue);\n        }}\n        defaultValue={2}\n      />\n      <Typography component=\"legend\">Read only</Typography>\n      <Rating name=\"read-only\" value={value} readOnly />\n      <Typography component=\"legend\">Disabled</Typography>\n      <Rating name=\"disabled\" value={value} disabled />\n      <Typography component=\"legend\">No rating given</Typography>\n      <Rating name=\"no-value\" value={null} />\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 35,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Rating from '@mui/material/Rating';\nimport Typography from '@mui/material/Typography';\n\nexport default function BasicRating() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [value, setValue] = React.useState<number | null>(2);\n\n  return (\n    <Box sx={{ '& > legend': { mt: 2 } }}>\n      <Typography component=\"legend\">Controlled</Typography>\n      <Rating\n        name=\"simple-controlled\"\n        value={value}\n        onChange={(event, newValue) => {\n          setValue(newValue);\n        }}\n      />\n      <Typography component=\"legend\">Uncontrolled</Typography>\n      <Rating\n        name=\"simple-uncontrolled\"\n        onChange={(event, newValue) => {\n          console.log(newValue);\n        }}\n        defaultValue={2}\n      />\n      <Typography component=\"legend\">Read only</Typography>\n      <Rating name=\"read-only\" value={value} readOnly />\n      <Typography component=\"legend\">Disabled</Typography>\n      <Rating name=\"disabled\" value={value} disabled />\n      <Typography component=\"legend\">No rating given</Typography>\n      <Rating name=\"no-value\" value={null} />\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 35,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Rating",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
